module.exports = __webpack_public_path__ + "img/lantern_under_the_invisibility_cloak.d0c8cb2f.jpg";